import React from "react";
import { MdArrowForwardIos } from "react-icons/md";

const QuestionList = ({ question }) => {
  const displayName =
    question?.user_name || question?.display_name || "Anonymous";
  const questionText =
    question?.question || question?.title || "Untitled question";
  const avatarLetter = displayName.charAt(0).toUpperCase();

  return (
    <div className="flex items-center justify-between px-6 py-4 hover:bg-gray-50 transition-colors">
      <div className="flex items-center gap-4 min-w-0">
        <div className="w-10 h-10 rounded-full bg-orange-100 text-orange-600 font-semibold flex items-center justify-center shrink-0">
          {avatarLetter}
        </div>
        <div className="min-w-0">
          <p className="text-sm text-gray-500 truncate">{displayName}</p>
          <p className="text-gray-800 truncate">{questionText}</p>
        </div>
      </div>
      <MdArrowForwardIos className="text-gray-400 shrink-0" />
    </div>
  );
};

export default QuestionList;
